let _unique = 1;

export function getUnique() {
    const value = _unique;
    _unique += 1;
    return value;
}
